module.exports = __webpack_public_path__ + "img/stock0.5318c953.png";